import { NotificationRuleNotificationType } from '@eppendorf/vnls-notifications-utils';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoList } from '$features/devices/device-information/info-list';
import { allNotificationTypes } from '$features/notifications/add-or-edit-notification-rule-dialog/constants';

import styles from './notification-detail-lifecycle.module.scss';

interface NotificationDetailLifecycleProps {
  notificationTypes?: NotificationRuleNotificationType[];
}

type DisplayNotificationType = Exclude<NotificationRuleNotificationType, 'Escalated'>;

export function NotificationDetailLifecycle({
  notificationTypes,
}: NotificationDetailLifecycleProps): ReactElement {
  const { t } = useTranslation();
  const activeNotificationTypes = notificationTypes?.length
    ? notificationTypes.filter(
        (type): type is DisplayNotificationType => type !== 'Escalated',
      )
    : allNotificationTypes;

  return (
    <InfoList>
      <InfoList.Title>{t('notificationDetail.lifecycle')}</InfoList.Title>
      <div className="m-top-l">
        <div>{t('notificationDetail.notificationWillBeSendOn')}</div>
        <ul
          className={`${styles.notificationTypes} m-top-l flex flex__dir--column gap-s`}
        >
          {activeNotificationTypes.map((type) => (
            <li key={type}>{t(`notificationRules.notificationTypes.${type}`)}</li>
          ))}
        </ul>
      </div>
    </InfoList>
  );
}
